import { call, put, takeLatest } from 'redux-saga/effects';
import { actions, types } from './duck';
import { updateUserMembership } from './api'; // renamed API function
import { OK } from 'http-status-codes';

function* updateMembershipSaga({user_id, user_type, membership}) {
  try {
    yield put(actions.updateMembershipRequest());

    const response = yield call(updateUserMembership, user_id, user_type, membership);
    if (response.status === OK) {
      yield put(actions.updateMembershipSuccess(response.data));
    } else {
      yield put(actions.updateMembershipFailure(response.statusText));
    }
  } catch (error) {
    yield put(actions.updateMembershipFailure(error.message));
  }
}

export default function* saga() {
  yield takeLatest(types.UPDATE_MEMBERSHIP, updateMembershipSaga);
}
